import type { ActivityResponse } from 'api/__GENERATED';

// Maps a single Activity DTO from the generated API client onto the
// normalized `Data.Activity` shape used throughout the store.
function toActivity(dto: ActivityResponse) {
  const {
    id,
    name,
    description,
    activityTypeId,
    activityCode,
    zoneId,
    subZoneIds,
  } = dto;

  const activity: Data.Activity = {
    id,
    name,
    description: description ?? '',
    activityTypeId,
    code: activityCode,
    zoneId,
    subZoneIds,
  };

  return activity;
}

export { toActivity };
